import { AgStudioLicenseManager } from 'ag-studio';
import { logger } from 'src/analytics/KatalLogger';
import { retrieveParameterFromSSM } from './ssm-parameter';

export const AgStudioLicenseKeyParameterStoreKey = '/xpt-fe/ag-studio-license';
export const configureAgStudioLicense = async (): Promise<string> => {
  const licenseKey = await retrieveParameterFromSSM(AgStudioLicenseKeyParameterStoreKey);
  if (licenseKey) {
    AgStudioLicenseManager.setLicenseKey(licenseKey);
    logger.info('AG Studio License configured successfully!', { logType: 'configStatus' });
    return 'setLicenseKey_Success';
  } else {
    logger.error('AG Studio License setup failed!', { logType: 'configStatus' });
    return Promise.reject(new Error('setLicenseKey_Failed'));
  }
};
